import { Phone, ClipboardList } from "lucide-react";
import { scrollToId } from "../lib/scroll";
import { BUSINESS } from "../constants/business";

export const MobileCta = () => (
  <div className="fixed bottom-0 left-0 right-0 z-40 lg:hidden grid grid-cols-2 border-t border-zinc-800 bg-[#0A0A0A]/95 backdrop-blur-md" data-testid="mobile-cta-bar">
    <a
      href={BUSINESS.phoneHref}
      data-testid="mobile-call-now-btn"
      className="flex items-center justify-center gap-2 py-4 font-oswald uppercase tracking-[0.15em] text-sm text-white border-r border-zinc-800 active:text-[#FF3B30]"
    >
      <Phone className="w-4 h-4 text-[#FF3B30]" /> Call Now
    </a>
    <button
      onClick={() => scrollToId("request")}
      data-testid="mobile-request-btn"
      className="flex items-center justify-center gap-2 py-4 font-oswald uppercase tracking-[0.15em] text-sm bg-[#FF3B30] text-white active:bg-white active:text-black"
    >
      <ClipboardList className="w-4 h-4" /> Request Service
    </button>
  </div>
);
